export default __webpack_public_path__ + "static/media/Go4_Logo_Login.570c2636.png";